export default {"src":"/_next/static/media/OVV.1c0b1c2e.svg","height":18,"width":18};